<div class="detail">

  @if(pdpService.isBatchManaged){

  <div class="catalog-code">
    {{'CAT CODE'|translate}}&nbsp;{{pdp?.catalogCode}}
  </div>

  }@else{

  <div class="catalog-code">
    {{pdp?.catalogCode}}
    @if(pdp?.equivalentCode){
    &nbsp;||&nbsp;EQ&nbsp;{{pdp?.equivalentCode}}
    }
    &nbsp;|&nbsp;
    {{pdp?.sapCode}}
  </div>

  }

  <div class="aesthetic-line">

    {{pdp?.aestheticLine}}

    @if(loading){

    <div class="spinner-wrapper">
      <div class="spinner-border text-primary mx-auto" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    }

  </div>

  @if(pdp && !pdpService.isBatchManaged){
  <app-multi-row-text-ellipsis [text]="pdp.description"></app-multi-row-text-ellipsis>
  }

  @if(price && canShowPrice){
  <div class="hr"></div>

  <div class="price-row">

    <div class="price">

      @if(includingTaxes){
      <span class="taxes fs-6">{{'Including taxes'|translate}}</span>
      }@else {
      <span class="taxes fs-6">{{'Excluding taxes'|translate}}</span>
      }

      <div class="price-label">
        {{priceLabel}}
      </div>

    </div>

  </div>

  }

  @if(showStock){

  @if(stock){
  <app-view-stock [viewStockType]="viewStockType" [stock]="stock" [sapCode]="pdp?.sapCode || ''"></app-view-stock>
  }

  @if(batchStock){
  <app-batch-stock [batchStock]="batchStock"></app-batch-stock>
  }

  @if(hewStock){
  <app-hew-stock [hewStock]="hewStock"></app-hew-stock>
  }

  @if(hqStock){
  <app-hq-stock [hqStock]="hqStock" [sapCode]="pdp?.sapCode || ''"></app-hq-stock>
  }

  @if(hqBatchStock){
  <app-hq-batch-stock [hqBatchStock]="hqBatchStock" [sapCode]="pdp?.sapCode || ''"></app-hq-batch-stock>
  }

  @if(showGlobalHqStock){
  <app-global-hq-stock [sapCode]="pdp?.sapCode || ''"></app-global-hq-stock>
  }

  }@else if(!loading){
  <app-placeholder [message]="'An error occurred while loading the stock'|translate"></app-placeholder>
  }


</div>
